import alertIcon from './icons/alert-white.png';
import sunnyDayWhite from './icons/animated/sunnydaywhite.gif';
import arrowLeft from './icons/editIcons/arrow_left.png';
import arrowRight from './icons/editIcons/arrow_right.png';
import toggleOn from './icons/editIcons/toggle-on.png';
import greenCheck from './icons/green-check.png';
import redCancel from './icons/red-cancel.png';
import sunrise from './icons/sun/sunrise.png';
import sunset from './icons/sun/sunset.png';
import twcSmallLogo from './icons/twc_logo.png';
import changeMapFilter from './map/change_map_filter.png';
import changeMapFilterFocused from './map/change_map_filter_focused.png';
import twcLogo from './placeholder/twc-logo.png';
import errorSymbol from './error-symbol.png';
import locationImageSource from './location.png';
import logo from './logo.png';
import logoEspanol from './logo_espanol.png';
import logoPattrn from './logo_pattrn.png';
import cableQRCode from './onboarding_QR.png';
import sadCloud from './sad_cloud.png';
import successCheckmark from './success_checkmark.png';
import videoStreamBackground from './video_stream.png';
import videoStreamPattrn from './video_stream_pattrn.png';
import videoStreamSpanishBackground from './video_stream_spanish.png';

export const assets = {
  alertIcon,
  sunnyDayWhite,
  arrowLeft,
  arrowRight,
  toggleOn,
  greenCheck,
  redCancel,
  sunrise,
  sunset,
  changeMapFilter,
  changeMapFilterFocused,
  twcLogo,
  errorSymbol,
  locationImageSource,
  logo,
  logoPattrn,
  logoEspanol,
  cableQRCode,
  sadCloud,
  successCheckmark,
  twcSmallLogo,
  videoStreamBackground,
  videoStreamPattrn,
  videoStreamSpanishBackground,
};

export { ALERTS_NON_PLATED_ICON_MAP } from './icons/alertsNonPlated/alerts_non_plated_icon_map';
